export function showKindly(show: boolean): void {
  const api = document.getElementById("kindly-chat-api");
  if (api !== null) {
    api.hidden = !show;
    api.inert = !show;
  }
}
